export default __webpack_public_path__ + "static/media/emoji-box.83944b7a.svg";